/**
 * Cow takeover toggle — Burning Man 2026 (Illumination Village, Mootopia camp).
 * Set to false after the event to restore the classic site.
 * Also restore the CLASSIC meta block in index.html (see comment there).
 */
export const COW_MODE = true;
